(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrap = document.getElementById('nfv2-newsletter');
    if (!wrap) return;
    var form = wrap.querySelector('#nfv2-form');
    var input = wrap.querySelector('#nfv2-input');
    var btn = wrap.querySelector('#nfv2-btn');
    var msgOk = wrap.querySelector('#nfv2-msg-success');
    var msgErr = wrap.querySelector('#nfv2-msg-error');
    var apiKey = wrap.dataset.apiKey;
    var tags = (wrap.dataset.tags || 'welcome_discount').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showOk() {
      msgOk.hidden = false;
      msgErr.hidden = true;
      form.hidden = true;
    }
    function showErr(text) {
      msgErr.textContent = text || 'Something went wrong. Try again.';
      msgErr.hidden = false;
      msgOk.hidden = true;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim().toLowerCase();
      if (!EMAIL_RE.test(email)) { showErr('Please enter a valid email.'); input.focus(); return; }
      if (!apiKey) { showErr('Form not configured. Contact support.'); return; }
      btn.disabled = true;
      var nowIso = new Date().toISOString();
      var payload = {
        identifiers: [{
          type: 'email',
          id: email,
          channels: { email: { status: 'subscribed', statusDate: nowIso } }
        }],
        tags: tags,
        consents: [{
          channel: 'email',
          source: 'form:nuroxlabs.com-footer',
          ip: 'n/a',
          userAgent: (navigator && navigator.userAgent) || 'n/a',
          createdAt: nowIso
        }],
        customProperties: {
          signup_source: 'footer',
          signup_at: nowIso
        }
      };
      fetch('https://api.omnisend.com/v3/contacts', {
        method: 'POST',
        headers: { 'X-API-KEY': apiKey, 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
      .then(function (res) {
        if (res.ok) return res.json().catch(function () { return {}; });
        return res.json().then(function (body) {
          throw new Error((body && (body.error || body.message)) || ('HTTP ' + res.status));
        }, function () {
          throw new Error('HTTP ' + res.status);
        });
      })
      .then(showOk)
      .catch(function (err) {
        console.error('[nfv2] Omnisend POST failed', err);
        showErr();
        btn.disabled = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nurox-feels-like"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var link = event.target.closest('[data-nx-feels-formula]');
  if (!link) return;
  var facts = document.getElementById('nx4-nutrition');
  if (!facts) return;
  facts.open = true;
  facts.querySelector('summary').focus({ preventScroll: true });
});

function initNuroxMotion(scope) {
  scope.querySelectorAll('[data-nx-feels-motion]').forEach(function(stage) {
    if (stage.dataset.initialized) return;
    stage.dataset.initialized = 'true';
    var video = stage.querySelector('video');
    var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var visible = false;
    var controller = new AbortController();
    var options = { signal: controller.signal };
    function syncPlayback() {
      if (!visible || document.hidden || preference.matches) {
        video.pause();
        return;
      }
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.muted = true;
      video.play().catch(function() { stage.classList.remove('is-ready'); });
    }
    video.addEventListener('playing', function() { stage.classList.add('is-ready'); }, options);
    video.addEventListener('error', function() { stage.classList.remove('is-ready'); }, options);
    document.addEventListener('visibilitychange', syncPlayback, options);
    preference.addEventListener('change', syncPlayback, options);
    var observer = new IntersectionObserver(function(entries) {
      visible = entries[0].isIntersecting;
      syncPlayback();
    }, { threshold: 0.15 });
    observer.observe(stage);
    document.addEventListener('shopify:section:unload', function(event) {
      if (!event.target.contains(stage)) return;
      observer.disconnect();
      video.pause();
      controller.abort();
    }, options);
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { initNuroxMotion(document); }, { once: true });
} else {
  initNuroxMotion(document);
}
document.addEventListener('shopify:section:load', function(event) { initNuroxMotion(event.target); });


function initNuroxBenefitSignal(scope){
  scope.querySelectorAll('.nx4__benefits').forEach(function(section){
    if(section.dataset.signalReady)return;
    section.dataset.signalReady='true';
    var visible=false;
    var controller=new AbortController();
    function sync(){section.toggleAttribute('data-motion-active',visible&&!document.hidden);}
    var observer=new IntersectionObserver(function(entries){
      visible=entries[0].isIntersecting;
      if(visible)section.setAttribute('data-entered','');
      sync();
    },{threshold:.1});
    observer.observe(section);
    document.addEventListener('visibilitychange',sync,{signal:controller.signal});
    document.addEventListener('shopify:section:unload',function(event){
      if(event.target.contains(section)){observer.disconnect();controller.abort();}
    },{signal:controller.signal});
  });
}
initNuroxBenefitSignal(document);
document.addEventListener('shopify:section:load',function(event){initNuroxBenefitSignal(event.target);});


  } catch(e) { console.error(e); }
})();
})();
